import { observable } from 'mobx';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { INoteAreaManager } from './note-area-manager.interface';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { CustomConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

const cacShowNote = appConfigInstance.getConfig<boolean>(CustomConfig.showNote as any) ?? true;

class NoteAreaManager implements INoteAreaManager {
    // TODO: note 的展示状态可以统一在一个地方维护，在 pc-canvas-injectable 里也有维护这个状态
    @observable public show = !browser.isMobile && cacShowNote;

    // 移动端列表页默认不展示备注
    @observable public listShow = false;

    // 是否进入移动端备注的编辑状态
    @observable public isMobileNoteFullScreen = false;

    public setShow() {
        this.show = true;
    }

    public setHide() {
        this.show = false;
    }

    public setListShow() {
        this.listShow = true;
    }

    public setListHide() {
        this.listShow = false;
    }

    public enterMobileFullScreen() {
        this.isMobileNoteFullScreen = true;
    }

    public leaveMobileFullScreen() {
        this.isMobileNoteFullScreen = false;
    }
}

export default NoteAreaManager;
